import {
    BASE_URL, 
    POST, 
    SUBMIT_BROADCAST,
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";
  
  export const submitBroadcastRequest = async (payload) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${SUBMIT_BROADCAST}`;
    return fetch(resource, {
      method: POST,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };